
(function (window, document, jQuery, undefined) {
    // map jQuery to local var
    var $ = jQuery.noConflict();

    // get list
    var $overviewTeaserLists = $('.overview-teaser-list');

    // btn click handler
    $overviewTeaserLists.find('.don-btn-load-more').on('click', function () {

        // show next teasers
        var rowId = $(this).data('for');
        var more = $(this).data('more');
        var $myTeasersToAdd = $('#' + rowId)
            .children('.d-none')
            .slice(0, more);
        $myTeasersToAdd.removeClass('d-none');

        // Trigger reflow before calculating heights
        $myTeasersToAdd.each(function () {
            this.offsetHeight; // Forces reflow
        });
        
        // change teasers left counter        
        var $counter = $(this).children('span').first();
        var currentCount = $counter.text();        
        var newCount = currentCount - more;        
        if (newCount <= 0) {
            $(this).parent().removeClass('d-flex');
            $(this).parent().addClass('d-none');
        } else {
            $counter.text(newCount);
        }

        setTimeout(function () {
            setSameHeight();
            setSameHeightImg();
        }, 0);

    });

    function setSameHeight() {
        var $body = $('body');
        var isSm = $body.hasClass('is-sm');

        $overviewTeaserLists.each(function () {

            // init vars
            var $teasers = $(this).find('.don-overview-page-teaser');            
            var maxTopicHeight = 0;
            var maxHeadlineHeight = 0;
            var maxContentHeight = 0;

            // clear height styles and find max heights
            $teasers.each(function () {
                var $teaser = $(this);                
                var $topic = $teaser.find('.don-overview-page-teaser__topic');
                var $headline = $teaser.find('.don-overview-page-teaser__headline');
                var $content = $teaser.find('.don-overview-page-teaser__content');

                $topic.removeAttr('style');
                $headline.removeAttr('style');
                $content.removeAttr('style');

                maxTopicHeight = $topic.height() > maxTopicHeight ? $topic.height() : maxTopicHeight;
                maxHeadlineHeight = $headline.height() > maxHeadlineHeight ? $headline.height() : maxHeadlineHeight;
                maxContentHeight = $content.height() > maxContentHeight ? $content.height() : maxContentHeight;
            });

            // skip if xs
            if (!isSm) {
                return;
            }

            // set max heights
            $teasers.each(function () {
                $teaser = $(this);
                var $topic = $teaser.find('.don-overview-page-teaser__topic');
                var $headline = $teaser.find('.don-overview-page-teaser__headline');
                var $content = $teaser.find('.don-overview-page-teaser__content');

                $topic.height(maxTopicHeight);
                $headline.height(maxHeadlineHeight);
                $content.height(maxContentHeight);
            });
        });
    }

    function setSameHeightImg() {
        var $body = $('body');
        var isSm = $body.hasClass('is-sm');

        $overviewTeaserLists.each(function () {

            // init vars
            var $teasers = $(this).find('.don-overview-page-teaser');
            var maxImgBoxHeight = 0;

            // clear height styles and find max heights
            $teasers.each(function () {
                var $teaser = $(this);
                var $imgBox = $teaser.find('.don-overview-page-teaser__img-box');

                $imgBox.removeAttr('style');

                maxImgBoxHeight = $imgBox.height() > maxImgBoxHeight ? $imgBox.height() : maxImgBoxHeight;
            });

            // skip if xs
            if (!isSm) {
                return;
            }

            // set max heights
            $teasers.each(function () {
                $teaser = $(this);
                var $imgBox = $teaser.find('.don-overview-page-teaser__img-box');

                $imgBox.height(maxImgBoxHeight);
            });
        });
    }

    var resizeTimer;
    $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            setSameHeight();
            setSameHeightImg();
        }, 200);
    });

    $(window).on("load", function () {
        var images = $("img").toArray();
        var loadPromises = [];
        
        images.forEach(function (img, index) {
            loadPromises.push(new Promise(function (resolve) {
                if (img.complete) {
                    resolve();
                } else {
                    $(img).on("load", function () {
                        resolve();
                    }).on("error", function () {
                        resolve();
                    });
                }
            }));
        });

        // ✅ Force execution after 3 seconds even if some images are slow
        var timeout = new Promise(function (resolve) {
            setTimeout(function () {
                resolve();
            }, 1000);
        });

        Promise.race([Promise.all(loadPromises), timeout]).then(function () {
            setSameHeight();
            setSameHeightImg();
        });
    });


    
})(window, document, jQuery);
